/**
 * Staff-door endpoints. Public identifiers only. No client secret lives in the SPA.
 *
 * Fold rebuild (2026-09-14): live Cognito staff client from D6W6B3zD lineage.
 * Cognito/allowlist/ACM untouched in this tip — SPA wiring only.
 */

export const STAFF_DOOR = {
  authorizeEndpoint:
    'https://dubbed-emr-149536453165.auth.us-east-1.amazoncognito.com/oauth2/authorize',
  tokenEndpoint: 'https://dubbed-emr-149536453165.auth.us-east-1.amazoncognito.com/oauth2/token',
  /**
   * Hosted-UI logout. GET with client_id + logout_uri. Clearing sessionStorage
   * alone leaves Cognito (and Google-via-Cognito) cookies warm.
   */
  logoutEndpoint: 'https://dubbed-emr-149536453165.auth.us-east-1.amazoncognito.com/logout',
  /** Live staff app client (nick@ Google SSO success tip D6W6B3zD). */
  clientId: '7026a2s920rpn17kf84qumcct8',
  scopes: [
    'openid',
    'dubbed-emr/staff.session',
    'dubbed-emr/chart.read',
    'dubbed-emr/chart.write',
    'dubbed-emr/encounter.read',
    'dubbed-emr/encounter.write',
    'dubbed-emr/orders.read',
    'dubbed-emr/orders.write',
    'dubbed-emr/documents.read',
    'dubbed-emr/documents.write',
  ],
} as const;

export interface LogoutParams {
  readonly clientId?: string;
  readonly logoutUri: string;
}

/**
 * Builds the Cognito hosted-UI logout URL. Does not navigate.
 * `logout_uri` must be an exact allowlisted origin root (trailing slash, no hash).
 */
export function buildLogoutUrl(params: LogoutParams): string {
  const url = new URL(STAFF_DOOR.logoutEndpoint);
  url.searchParams.set('client_id', params.clientId ?? STAFF_DOOR.clientId);
  url.searchParams.set('logout_uri', params.logoutUri);
  return url.toString();
}
